export default {
  // listTitleTable: {
  //   Order: 'Order',
  //   Ticker: 'Ticker',
  //   TradingTime: 'TradingTime',
  //   OrderPrice: 'OrderPrice',
  //   MatchedPrice: 'MatchedPrice',
  //   Volume: 'Volume',
  //   OrderStatus: 'OrderStatus',
  //   OrderAction: 'OrderAction',
  // },
  listTiteComponent: {
    Account: 'Tài khoản',
    TotalPrice: 'Tổng tiền ',
    TotalDebt: 'Tổng nợ',
    Order: 'Đặt lệnh',
    OrderBook: 'Sổ lệnh',
    Volume: 'Khối lượng',
    Ceiling: 'TRẦN',
    Reference: 'TC',
    Floor: 'SÀN',
    Max: 'Tối đa',
    MatchedPrice: 'Giá khớp',
    Price: 'Giá',
    StockValue: 'Chứng Khoán',
    NetAssetValue: 'Tài sản ròng',
    PurchasingPower: 'Sức mua',
    TradeQuantity: 'Khối lượng bán',
    MaxVolume: 'Khối lượng mua tối đa',
  },
  listTitleTable: {
    symbol: 'Mã',
    price: 'Giá đặt',
    side: 'Lệnh',
    status: 'Trạng thái',
    quantity: 'Khối lượng',
    avgPrice: 'Giá khớp',
    createdDate: 'Thời gian',
    cancelVolume: 'Khối lượng hủy',
  },
  listStatusType: {
    GETALL: 'Tất cả',
    PENDINGNEW: 'Chờ gửi',
    NEW: 'Chờ khớp',
    // SENT: '',
    PARTIALLYFILLED: 'Khớp một phần',
    FILLED: 'Khớp toàn phần',
    REJECTED: 'Từ chối',
    EXPIRED: 'Hết hiệu lực',
    PENDINGCANCEL: 'Lệnh chờ hủy',
    CANCELLED: 'Hủy',
  },
  listTextOrderPopup: {
    TextPARTNERS: 'Đối tác của Fiintrade',
    TextOtherPARTNERS: 'Các công ty chứng khoán khác',
    TextConditions: 'Điều khoản dịch vụ',
    TextAgreed: 'Tôi đã đọc và đồng ý với điều khoản của FiinTrade.',
    SaveOTP: 'Lưu xác thực OTP',
    ResendOTP: 'Gửi lại OTP',
    ResendOTPIn: 'Gửi lại trong',
  },
  listActionOrderPopup: {
    Login: 'Đăng Nhập',
    Agree: 'Đồng ý',
  },
  messageErrors: {
    PriceLessFloor: 'Giá nhập nhỏ hơn giá sàn',
    PriceHigherCelling: 'Giá nhập lớn hơn giá trần',
    PriceInvalid: 'Giá nhập không hợp lệ',
    VolumeHigherQmax: 'Khối lượng đặt lớn hơn khối lượng mua/bán tối đa',
    VolumeInvalid: 'Khối lượng không hợp lệ',
    Please: 'Vui lòng thử lại!',
    Error: 'Lỗi',
  },
  titileTooltip: {
    Money: 'Tiền:',
    TermDeposit: 'Tiền gửi có kỳ hạn:',
    CashDividendReceiving: 'Tiền cổ tức tiền chờ về:',
    DepositInterest: 'Lãi tiền gửi:',
    ReceivingAmount: 'Chờ về:',
    SecureAmount: 'Tiền mua khớp T0:',
    MarginDebt: 'Nợ margin:',
    WithdrawableCash: 'Nợ phí,UTTB:',
    Copy: 'Sao chép lệnh',
    Cancle: 'Hủy lệnh',
  },
  orderType: {
    LO: 'Chủ động nhập giá giao dịch',
    ATO: 'GD tại mức giá mở cửa',
    ATC: 'GD tại mức giá đóng cửa',
    MP: 'GD tại giá thị trường, phần chưa khớp chuyển lệnh LO',
    PLO: 'GD tại mức giá đóng cửa sau khi hết phiên',
    MTL: 'GD tại mọi giá, phần chưa khớp chuyển thành lệnh LO',
    MOK: 'GD tại mọi giá hoặc hủy nếu không khớp được toàn bộ',
    MAK: 'GD tại mọi giá, phần chưa khớp sẽ bị hủy',
  },
};
